import Slides from './Slides.js';

import img1 from './images/portfolio/family-and-kids/006.jpg';
import img2 from './images/portfolio/family-and-kids/008.jpg';
import img3 from './images/portfolio/family-and-kids/032.jpg';
import img4 from './images/portfolio/family-and-kids/052.jpg';
import img5 from './images/portfolio/family-and-kids/082.jpg';
import img6 from './images/portfolio/family-and-kids/102509_029.jpg';
import img7 from './images/portfolio/family-and-kids/102509_060.jpg';
import img8 from './images/portfolio/family-and-kids/20081229_1523_R.jpg';
import img9 from './images/portfolio/family-and-kids/Benazzi_Family_IMG_018.jpg';
import img10 from './images/portfolio/family-and-kids/Composite_2_DSC_810_0026_.jpg';
import img11 from './images/portfolio/family-and-kids/Composite_finished.jpg';
import img12 from './images/portfolio/family-and-kids/Copy_of_DSC_0041.jpg';
import img13 from './images/portfolio/family-and-kids/DSC_0051.jpg';
import img14 from './images/portfolio/family-and-kids/DSC_0057.jpg';
import img15 from './images/portfolio/family-and-kids/Fine_IMG0661.jpg';
import img16 from './images/portfolio/family-and-kids/Finished_IMG4994.jpg';
import img17 from './images/portfolio/family-and-kids/IMG_007.jpg';
import img18 from './images/portfolio/family-and-kids/IMG_008_r.jpg';
import img19 from './images/portfolio/family-and-kids/IMG_013.jpg';
import img20 from './images/portfolio/family-and-kids/IMG_022_Finished.jpg';
import img21 from './images/portfolio/family-and-kids/IMG_022_finished_bw.jpg';
import img22 from './images/portfolio/family-and-kids/IMG_028.jpg';
import img23 from './images/portfolio/family-and-kids/IMG_036.jpg';
import img24 from './images/portfolio/family-and-kids/IMG_045.jpg';
import img25 from './images/portfolio/family-and-kids/IMG_085.jpg';
import img26 from './images/portfolio/family-and-kids/IMG_102.jpg';
import img27 from './images/portfolio/family-and-kids/Img0017.jpg';
import img28 from './images/portfolio/family-and-kids/Img0023.jpg';
import img29 from './images/portfolio/family-and-kids/Img0024.jpg';
import img30 from './images/portfolio/family-and-kids/Img003_fin7.jpg';
import img31 from './images/portfolio/family-and-kids/Img0114.jpg';
import img32 from './images/portfolio/family-and-kids/Img014.jpg';
import img33 from './images/portfolio/family-and-kids/Img047.jpg';
import img34 from './images/portfolio/family-and-kids/Img063.jpg';
import img35 from './images/portfolio/family-and-kids/Img081.jpg';
import img36 from './images/portfolio/family-and-kids/Img086.jpg';
import img37 from './images/portfolio/family-and-kids/Leogrande_036.jpg';
import img38 from './images/portfolio/family-and-kids/Roel_IMG6593.jpg';
import img39 from './images/portfolio/family-and-kids/Speranza_084.jpg';
import img40 from './images/portfolio/family-and-kids/DSC0067.jpg';
import img41 from './images/portfolio/family-and-kids/DSC4742.jpg';
import img42 from './images/portfolio/family-and-kids/IMG0081.jpg';
import img43 from './images/portfolio/family-and-kids/IMG0116.jpg';
import img44 from './images/portfolio/family-and-kids/IMG0678.jpg';
import img45 from './images/portfolio/family-and-kids/IMG1080.jpg';
import img46 from './images/portfolio/family-and-kids/IMG1681_r.jpg';
import img47 from './images/portfolio/family-and-kids/IMG1828.jpg';
import img48 from './images/portfolio/family-and-kids/IMG2071.jpg';
import img49 from './images/portfolio/family-and-kids/IMG2203.jpg';
import img50 from './images/portfolio/family-and-kids/IMG2861.jpg';
import img51 from './images/portfolio/family-and-kids/IMG3122.jpg';
import img52 from './images/portfolio/family-and-kids/IMG3194.jpg';
import img53 from './images/portfolio/family-and-kids/IMG3208.jpg';
import img54 from './images/portfolio/family-and-kids/IMG3693.jpg';
import img55 from './images/portfolio/family-and-kids/IMG3775.jpg';
import img56 from './images/portfolio/family-and-kids/IMG4002.jpg';
import img57 from './images/portfolio/family-and-kids/IMG4054.jpg';
import img58 from './images/portfolio/family-and-kids/IMG4114.jpg';
import img59 from './images/portfolio/family-and-kids/IMG4145.jpg';
import img60 from './images/portfolio/family-and-kids/IMG4221_r.jpg';
import img61 from './images/portfolio/family-and-kids/IMG5122.jpg';
import img62 from './images/portfolio/family-and-kids/IMG5810.jpg';
import img63 from './images/portfolio/family-and-kids/IMG5846.jpg';
import img64 from './images/portfolio/family-and-kids/IMG6241.jpg';
import img65 from './images/portfolio/family-and-kids/IMG6981r.jpg';
import img66 from './images/portfolio/family-and-kids/IMG7170.jpg';
import img67 from './images/portfolio/family-and-kids/IMG7295.jpg';
import img68 from './images/portfolio/family-and-kids/IMG8565.jpg';
import img69 from './images/portfolio/family-and-kids/finished_img_052.jpg';
import img70 from './images/portfolio/family-and-kids/image_0090.jpg';
import img71 from './images/portfolio/family-and-kids/img_030.jpg';

const images = [ 
    img1,
    img2,
    img3,
    img4,
    img5,
    img6,
    img7,
    img8,
    img9,
    img10,
    img11,
    img12,
    img13,
    img14,
    img15,
    img16,
    img17,
    img18,
    img19,
    img20,
    img21,
    img22,
    img23,
    img24,
    img25,
    img26,
    img27,
    img28,
    img29,
    img30,
    img31,
    img32,
    img33,
    img34,
    img35,
    img36,
    img37,
    img38,
    img39,
    img40,
    img41,
    img42,
    img43,
    img44,
    img45,
    img46,
    img47,
    img48,
    img49,
    img50,
    img51,
    img52,
    img53,
    img54,
    img55,
    img56,
    img57,
    img58,
    img59,
    img60,
    img61,
    img62,
    img63,
    img64,
    img65,
    img66,
    img67,
    img68,
    img69,
    img70,
    img71,
];

function ChurchesSchoolsAndSports() {
    return <Slides images={images}/>;
}

export default ChurchesSchoolsAndSports;
